import { render } from "./PlayerModal.vue?vue&type=template&id=9e5d1898&scoped=true"
import script from "./PlayerModal.vue?vue&type=script&lang=js"
export * from "./PlayerModal.vue?vue&type=script&lang=js"

import "./PlayerModal.vue?vue&type=style&index=0&id=9e5d1898&lang=css&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\game-forecast\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e5d1898"]])

export default __exports__